import { isNotEmpty } from "utils/validation"
import dateService from "services/date"

import {
	HORS_AM_GENDER,
	AM_GENDER,
	genderMFCList,
	MFC_RETAIL_GENDER,
	BC_OPERATOR,
	partnerChainList,
} from "utils/constants"

export const fetchPartner = async (entity, setPartner) => {
	const mfc_client_number = ""
	const gender_mfc = genderMFCList.find(
		(oneGenderMFC) => oneGenderMFC.id_api === MFC_RETAIL_GENDER
	)
	const isBCOperator = entity?.data_operators?.find(
		(oneOperator) => oneOperator.operator === BC_OPERATOR
	)

	const newPartner = {
		entity_id: entity?.entity_id || "",
		status: entity?.status || "",
		row_hash: entity?.row_hash || "",
		manager: entity?.user_referent || {},
		is_activate_by_G8: entity?.futurosoft?.is_activate_by_G8 || false,

		gender: entity?.gender?.toString ? entity?.gender : "",
		gender_mfc: gender_mfc?.value || 0,
		mfc_client_number: mfc_client_number,
		declarator_number: entity?.entity_id || "",
		bicycode_state: entity?.create_date
			? dateService.formatDate(entity?.create_date, "dd/MM/y")
			: "",

		// Structure
		raison_sociale: entity?.entity_data?.raison_sociale || "",
		code_ape: entity?.entity_data?.code_ape || "",
		nom_commercial: entity?.entity_data?.nom_commercial || "",
		siret: entity?.entity_data?.siret || "",
		tva_intra: entity?.entity_data?.tva_intra || "",
		structureChainName: entity?.entity_data?.est_une_chaine
			? partnerChainList.find(
					(onePartnerChain) => onePartnerChain.value === entity?.entity_data?.code_chaine
			  )
			: "",
		isFranchise: entity?.entity_data?.est_une_chaine?.toString() || "false",
		isMaker: entity?.entity_data?.est_un_fabricant?.toString() || "false",
		isFub: entity?.entity_data?.is_fub || "false",
		numero_et_voie: entity?.entity_data?.adresse?.numero_et_voie || "",
		code_postal: entity?.entity_data?.adresse?.code_postal || "",
		ville: entity?.entity_data?.adresse?.ville || "",
		pays: entity?.entity_data?.adresse?.pays || "",
		code_insee: entity?.entity_data?.adresse?.code_insee || "",
		telephone_2: entity?.entity_data?.telephone_2 || "",
		latitude: entity?.entity_data?.latitude,
		longitude: entity?.entity_data?.longitude,
		site_web: entity?.entity_data?.site_web || "",
		est_bicytrust: entity?.entity_data?.est_bicytrust || false,

		// Specificity for BC operator
		...(() => {
			if (isNotEmpty(isBCOperator)) {
				const BCEntityData = isBCOperator.entity_data

				return {
					payment_type: isNotEmpty(BCEntityData.iban) ? 0 : 1,
					bc_bic: BCEntityData.bic || "",
					bc_iban: BCEntityData.iban || "",
					bc_bank_name: BCEntityData.bank_name || "",
					bc_effective_date: BCEntityData.effective_date || "",
					bc_rum: BCEntityData.rum || "",
					invoicing_agent_mail: BCEntityData.invoicing_agent_mail || "",
					invoicing_agent_firstname: BCEntityData.invoicing_agent_firstname || "",
					invoicing_agent_lastname: BCEntityData.invoicing_agent_lastname || "",
				}
			}
		})(),

		// Specificity for AM and HAM
		...(() => {
			// Alsace Moselle
			if (entity?.gender === AM_GENDER) {
				// we create next a new date like new Date("03/12/2021")
				const str = entity?.entity_data?.siret
				return {
					registre_date:
						str?.substring(2, 4) +
						"/" +
						str?.substring(0, 2) +
						"/" +
						str?.substring(4, 8),
					registre_volume: str?.substring(8, 11),
					registre_folio: str?.substring(11, 14),
				}
			} else {
				return {
					registre_date: new Date(),
					registre_volume: "",
					registre_folio: "",
				}
			}
		})(),

		rna:
			entity?.gender === HORS_AM_GENDER
				? entity?.entity_data?.siret.replace("WWWWW", "")
				: "",

		// Manager
		nom_representant_legal: entity?.entity_data?.nom_representant_legal || "",
		prenom_representant_legal: entity?.entity_data?.prenom_representant_legal || "",
		mail: entity?.entity_data?.mail || "",
		telephone_1: entity?.entity_data?.telephone_1 || "",
		workingHours: entity?.entity_data?.horaires_ouverture,
	}
	setPartner(newPartner)
}
